export const SOCIAL_PROFILES_ACTION_PARAM = {
    NAME: 'action',
    VALUES: {
        ADD_SOCIAL_PROFILES: 'add_social_profiles'
    }
};
